import Vue from  "vue";
import BannerSignup from "./banner-signup.vue";

const utmSourceNewTab = 'new-tab';
const sessionStorageKey = 'new-tab-newsletter';
const newsletterConfig = {
  source: '2Q',
  optin: '1',
  flags: "What'sNew",
};

const dismissNewsletter = () => {
  sessionStorage.setItem(sessionStorageKey, 'dismissed');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'gtm.DismissNewsletterAsk',
    source: newsletterConfig.source,
  });
};

const initBannerSignup = () => {
  const bannerTray = document.querySelector('[data-banner-tray]');
  const bannerSignupEl = document.createElement('banner-signup');
  bannerTray.prepend(bannerSignupEl);

  new Vue({
    el: bannerSignupEl,
    components: { BannerSignup },
    data: { config: newsletterConfig },
    methods: {
      dismiss: dismissNewsletter,
    },
    template: '<banner-signup :newsletter-config="config" @dismiss="dismiss"/>',
  });
  return true;
};

const isDismissed = () => {
  return !!sessionStorage.getItem(sessionStorageKey) && sessionStorage.getItem(sessionStorageKey) === 'dismissed';
};

const fromNewTab = () => {
  let params = new URLSearchParams(window.location.search)
  return params.get('utm_source') == utmSourceNewTab;
}

document.addEventListener("DOMContentLoaded", (e) => {
  if (!fromNewTab()) {
    return;
  }
  if (isDismissed()) {
    return;
  }

  initBannerSignup();
});
